// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__15VHn","insightsList":"newBusinessInsightsMenu_insightsList__2JUe8","active":"newBusinessInsightsMenu_active__AgyrD"};